// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ja7aC","content":"styles_content__v1xdS"};